import { IKnmPreview } from 'ApiPackage/SearchModule/interfaces/IKnmPreview';

import { KnmSubtitle } from './KnmSubtitle';
import styles from './styles.module.scss';
import { parseErknmValue } from '../common/parseErknmValue';

interface IPmResultDecisionsProps {
  passportData?: IKnmPreview;
}

export const PmResultDecisions = ({ passportData }: IPmResultDecisionsProps) => {
  const decisions = passportData?.pmErknm?.subject?.resultDecisions;

  return (
    <div className={styles.ColumnContent}>
      {!!decisions?.length && (
        <KnmSubtitle title="Сведения о решениях, принятых по результатам ПМ">
          {decisions.map((decision, index) => {
            const signerTitle = decision.titleSigner?.value
              ? parseErknmValue<{ title?: string }>(decision.titleSigner.value)?.title
              : undefined;

            return (
              <div className={styles.SectionBlock} key={index}>
                <div className={styles.SectionTitle}>Сведения о решении #{index + 1}</div>
                {decision.kindDecision?.name && (
                  <div className={styles.Row}>
                    <div className={styles.ColText}>Вид решения</div>
                    <div className={styles.ColValue}>{decision.kindDecision.name}</div>
                  </div>
                )}
                {decision.numberDecision && (
                  <div className={styles.Row}>
                    <div className={styles.ColText}>Номер решения</div>
                    <div className={styles.ColValue}>{decision.numberDecision}</div>
                  </div>
                )}
                {decision.fioSigner && (
                  <div className={styles.Row}>
                    <div className={styles.ColText}>ФИО подписавшего решение</div>
                    <div className={styles.ColValue}>{decision.fioSigner}</div>
                  </div>
                )}
                {signerTitle && (
                  <div className={styles.Row}>
                    <div className={styles.ColText}>Должность лица, подписавшего решение</div>
                    <div className={styles.ColValue}>{signerTitle}</div>
                  </div>
                )}
              </div>
            );
          })}
        </KnmSubtitle>
      )}
    </div>
  );
};
